import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Package } from 'lucide-react';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="relative w-full min-h-[100dvh] flex flex-col justify-center items-center px-4 pt-6 pb-6 md:py-32" data-id="element-163">
      <div className="max-w-5xl mx-auto text-center w-full" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          {/* Badge */}
          <div className="inline-block mb-3 md:mb-8 px-3 py-1.5 md:px-6 md:py-3 bg-bg-card border border-border-card rounded-full text-[11px] md:text-base text-text-secondary" data-id="element-166">
            VOLEY 360 — Colección Completa del Entrenador
          </div>

          {/* Headline */}
          <h1 className="text-[32px] leading-[1.05] sm:text-5xl md:text-7xl lg:text-8xl font-black tracking-tight mb-4 md:mb-6" data-id="element-167">
            Todo tu año de vóley
            <br data-id="element-168" />
            <span className="text-orange" data-id="element-169">resuelto de una vez.</span>
          </h1>

          {/* Product image — bigger on mobile, with subtle glow behind */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="relative flex justify-center my-4 md:my-10" data-id="element-170">
            {/* Soft celeste glow behind product */}
            <div aria-hidden="true" className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-171">
              <div className="w-[280px] h-[200px] md:w-[600px] md:h-[400px] rounded-full bg-orange/15 blur-3xl" data-id="element-172" />
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/qX9iX4xL8enu21MycHRUow/188.png" alt="Megapack VOLEY 360 — Colección completa del entrenador con todos los tomos y bonus" loading="eager" decoding="async"
          // @ts-ignore - fetchpriority is a valid HTML attribute, types may be outdated
          fetchpriority="high" width="1024" height="1280" className="relative w-auto max-h-[260px] sm:max-h-[340px] md:max-h-none md:w-full md:max-w-2xl drop-shadow-2xl" style={{
            filter: 'drop-shadow(0 20px 40px rgba(255, 107, 26, 0.3))'
          }} data-id="element-173" />
          </motion.div>

          {/* Subtitle */}
          <p className="text-sm sm:text-base md:text-2xl text-text-secondary mb-4 md:mb-12 font-medium" data-id="element-174">
            Sesiones · Técnica · Táctica · Drills · Planificación · Negocio
          </p>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-5 md:mb-12" data-id="element-175">
            <div className="flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-176">
              <FileText className="w-3.5 h-3.5 md:w-5 md:h-5 text-orange" data-id="element-177" />
              <span className="text-xs md:text-sm font-medium" data-id="element-178">PDF</span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-179">
              <Zap className="w-3.5 h-3.5 md:w-5 md:h-5 text-orange" data-id="element-180" />
              <span className="text-xs md:text-sm font-medium" data-id="element-181">
                Acceso Inmediato
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-182">
              <Package className="w-3.5 h-3.5 md:w-5 md:h-5 text-orange" data-id="element-183" />
              <span className="text-xs md:text-sm font-medium" data-id="element-184">
                12 Tomos + 6 Bonus + 2 Élite
              </span>
            </div>
          </div>

          {/* Primary CTA — bigger, full width on mobile, with glow */}
          <motion.button onClick={onCTAClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full sm:inline-block sm:w-auto px-6 md:px-12 py-4 md:py-6 bg-orange text-white text-base md:text-xl font-black rounded-card shadow-2xl hover:bg-orange/90 transition-all mb-4 md:mb-8" style={{
          boxShadow: '0 10px 40px -10px rgba(255, 107, 26, 0.6), 0 0 0 1px rgba(255, 107, 26, 0.2)'
        }} data-id="element-185">
            💪 QUIERO MI VOLEY 360 AHORA
          </motion.button>

          {/* Trust line */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 md:gap-6 text-[11px] md:text-sm text-text-secondary" data-id="element-186">
            <div className="flex items-center gap-1" data-id="element-187">
              <span data-id="element-188">🛡️</span>
              <span data-id="element-189">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-190">
              <span data-id="element-191">🔒</span>
              <span data-id="element-192">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-193">
              <span data-id="element-194">💳</span>
              <span data-id="element-195">Tarjetas y transferencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}